/**
 * Tooltip generico riutilizzabile per controlli (pulsanti, icone, chip).
 * Stesso stile della rail di navigazione: box scuro, compare al passaggio
 * del mouse (e al focus da tastiera, per accessibilità).
 *
 * Uso:
 *   <Tooltip label="Segna come spam" side="top">
 *     <button>…</button>
 *   </Tooltip>
 *
 * Il wrapper è inline-flex e non altera il layout del figlio.
 */
import type { ReactNode } from 'react';

type Side = 'top' | 'bottom' | 'left' | 'right';

// Posizione del box rispetto al figlio, in classi Tailwind.
const SIDE_POS: Record<Side, string> = {
  top: 'bottom-full left-1/2 mb-1.5 -translate-x-1/2',
  bottom: 'top-full left-1/2 mt-1.5 -translate-x-1/2',
  left: 'right-full top-1/2 mr-1.5 -translate-y-1/2',
  right: 'left-full top-1/2 ml-1.5 -translate-y-1/2',
};

export function Tooltip({
  label,
  side = 'top',
  children,
}: {
  label: ReactNode;
  side?: Side;
  children: ReactNode;
}) {
  return (
    <span className="group/tt relative inline-flex">
      {children}
      <span
        role="tooltip"
        className={`pointer-events-none absolute z-50 max-w-[260px] whitespace-normal rounded-md px-2.5 py-1.5 text-[11px] font-medium leading-snug opacity-0 shadow-lg transition-opacity delay-150 duration-100 group-hover/tt:opacity-100 group-focus-within/tt:opacity-100 ${SIDE_POS[side]}`}
        style={{ background: '#18181b', color: '#fafafa', border: '1px solid #3f3f46' }}
      >
        {label}
      </span>
    </span>
  );
}
